import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=9606cbf4&scoped=true&"
import script from "./Confirm.vue?vue&type=script&lang=js&"
export * from "./Confirm.vue?vue&type=script&lang=js&"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=9606cbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9606cbf4",
  null
  
)

/* custom blocks */
import block0 from "./Confirm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9606cbf4')) {
      api.createRecord('9606cbf4', component.options)
    } else {
      api.reload('9606cbf4', component.options)
    }
    module.hot.accept("./Confirm.vue?vue&type=template&id=9606cbf4&scoped=true&", function () {
      api.rerender('9606cbf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Confirm.vue"
export default component.exports